<template>
  <div class="shop-list">
    <div class="shop-header" v-if='isSHowHeader'>
      <div class="title">商城专区</div>
      <a href="" class="more">查看更多 &gt;</a>
    </div>
    <div class="coupon-list">
      <div class="coupon-item">
        <div class="coupon-header">
          满减券
        </div>
        <div class="coupon-available-box-body">
          <div class="shop-name">
            易通金贸自营店铺
          </div>
          <div class="coupon-info">
            <span class="unit">￥</span> <span class="price">100</span> <span class="detail">满2000可用</span>
            <div class="address-new">立即领取</div>
          </div>
          <div class="coupon-other">
            *商品金额需大于优惠金额，不可叠加
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  props: {
    isSHowHeader: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  created() {},
  computed: {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.shop-list {
  margin-top: 0.25rem;
  //margin-bottom: 0.2rem;
  padding: 0rem 0.2rem;
  /*background-color: #fff;*/
}

.shop-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.28rem;

  .title {
    font-size: 0.15rem;
    color: #333;
    font-weight: 800;
  }

  .more {
    font-size: 0.12rem;
    color: #999;
  }
}

.my-coupon{
  position: fixed;
  right: 0.1rem;
  bottom: 0.5rem;
  width: 1rem;
  height: 1.02rem;
}
</style>
